import AdminDocumentsPage from "./AdminDocumentsPage";

export default AdminDocumentsPage;
